
import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'


import { Core } from './../core/core'

// components & services
import { SeMembershipCardService } from './membership-card.service'
import { SeMembershipCardComponent } from './membership-card.component'

// dependencies
import { SeDateTimeModule } from '../date-time/date-time.module'
import { SeIconModule } from './../icon/icon.module'
import { SeMenuModule } from './../menu/menu.module'
import { SePersonaAvatarModule } from './../persona-avatar/persona-avatar.module'
import { SeTagModule } from './../tag/tag.module'
import { SeTagGroupModule } from './../tag-group/tag-group.module'
import { SeAvatarGroupModule } from '../avatar-group/avatar-group.module'

@NgModule({
  imports: [
	CommonModule, 
    SeAvatarGroupModule,
    SeDateTimeModule,
    SeIconModule,
    SeMenuModule,
    SePersonaAvatarModule,
    SeTagModule,
    SeTagGroupModule
  ],
  declarations: [
    SeMembershipCardComponent
  ],
  providers: [
    SeMembershipCardService,
  ],
  exports: [
    SeMembershipCardComponent,
  ]
})
export class SeMembershipCardModule {}

export const SE_MEMBERSHIP_CARD_MODULE_BUNDLE = `${Core.ANGULAR_MODULE}.membershipCard`

